import { render, staticRenderFns } from "./FeaturedBannersForm.vue?vue&type=template&id=66e50808&scoped=true&"
import script from "./FeaturedBannersForm.vue?vue&type=script&lang=js&"
export * from "./FeaturedBannersForm.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedBannersForm.vue?vue&type=style&index=0&id=66e50808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e50808",
  null
  
)

export default component.exports